import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, TextField, Switch, FormControlLabel, Chip, CircularProgress, Alert } from '@mui/material';
import { LocationOn } from '@mui/icons-material';
import useGeolocation from '../../../../../../hooks/useGeolocation';
import LocationTroubleshoot from '../../../../../../components/LocationTroubleshoot';



const PunchLocationBadge = ({ callBack }) => {
    const [dialogStatus, setDialogStatus] = useState(false);
    const [notify, setNotify] = useState(false);
    const [remark, setRemark] = useState("");
    
    // Using your custom hook
    const { getLocation, locatingLoading, geoLocationError, location } = useGeolocation();

    const handleOpen = async () => {
        setDialogStatus(true);
        // Automatically try to get location when dialog opens
        await getLocation();
    };

    const handleUpdate = () => {
        if (!remark.trim()) return;

        if (callBack) {
            callBack({
                remark: remark,
                notify: notify,
                // Passing coordinates alongside the remark
                lat: location?.lat || null,
                lng: location?.lng || null,
                isLocationPunch: true // Flag to identify this in the activity log
            });
        }
        setDialogStatus(false);
        setRemark(""); 
    };

    return (
        <>
            <Chip 
                icon={locatingLoading ? <CircularProgress size={16} /> : <LocationOn style={{ fontSize: '16px' }} />}
                label="Punch Location"
                onClick={handleOpen}
                variant="outlined"
                color="secondary"
                sx={{ 
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    '& .MuiChip-label': { px: 1 }
                }} 
            />

            <Dialog
                open={dialogStatus}
                onClose={() => setDialogStatus(false)}
                fullWidth={true}
                maxWidth="xs"
            >
                <div className='p-3 fw-bold border-bottom d-flex justify-content-between align-items-center'>
                    Add Location Remark
                    {locatingLoading && <CircularProgress size={20} />}
                </div>
                <DialogContent>
                    <div className='row mt-2'>
                        <div className='col-md-12'>
                            {/* Location Status Display */}
                            {geoLocationError ? (
                                <div className="alert alert-danger" role="alert">
                                    <h4 className="alert-heading">Error</h4>
                                    <p>{geoLocationError} - <button className='btn btn-danger' onClick={getLocation}>Retry</button></p>
                                    <hr/>
                                    <LocationTroubleshoot/>
                                </div>
                            ) : location ? (
                                <Alert severity="success" className="mb-2" sx={{ fontSize: '0.8rem' }}>
                                    Location Captured: 
                                    {/* location.lat.toFixed(4)}, {location.lng.toFixed(4) */}
                                </Alert>
                            ) : null}

                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                label="Update/Remark at this location"
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                margin="normal"
                                placeholder="What are you doing at this location?"
                                autoFocus
                            />

                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={notify}
                                        onChange={(e) => setNotify(e.target.checked)}
                                    />
                                }
                                label="Notify team via email"
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="p-3">
                    <button className='btn btn-light' onClick={() => setDialogStatus(false)}>Cancel</button>
                    <button 
                        className='btn btn-primary' 
                        onClick={handleUpdate}
                        disabled={!remark.trim() || locatingLoading}
                    >
                        {locatingLoading ? "Fetching GPS..." : "Punch & Update"}
                    </button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PunchLocationBadge;